<script lang="ts" setup>
  import Icon from "@/components/Icon.vue";
  import { useThemeStore } from "@/stores/theme";

  const themeStore = useThemeStore();
  const theme = themeStore.getThemeDefinition();

  const COLOR_START_DEFAULT = '#0099EB';
  const COLOR_END_DEFAULT = '#025085';

  const props = withDefaults(
    defineProps<{
      size?: number;
      icon?: string;
      iconSize?: number;
      colorStart?: string;
      colorEnd?: string;
    }>(),
    {
      size: 80,
      icon: 'credit_card',
      iconSize: 47,
    },
  );
</script>

<template>
  <div
    class="icon-container"
    :style="{
      minHeight: `${props.size}px`,
      height: `${props.size}px`,
      minWidth: `${props.size}px`,
      width: `${props.size}px`,
      background: `radial-gradient(86.54% 86.54% at 23.46% 23.85%, ${props.colorStart ?? theme?.colors?.primary ?? COLOR_START_DEFAULT} 0%, ${props.colorEnd ?? theme?.colors?.['primary-300'] ?? COLOR_END_DEFAULT} 100%)`,
    }"
  >
    <Icon :size="props.iconSize" :icon="props.icon"></Icon>
  </div>
</template>

<style lang="scss" scoped>
  .icon-container {
    border-radius: 50%;
    box-shadow: 0px 0px 1.23077px 4.92308px rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
  }
</style>
